import { Component, Input, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedService } from '@shared/services/shared.service';
import { IOfficeHours } from 'app/models/licenses/office-hours';
import { OfficeHoursService } from 'app/services/license/office-hours.service';

@Component({
  selector: 'app-office-hours',
  templateUrl: './office-hours.component.html',
  styleUrls: ['./office-hours.component.scss']
})
export class OfficeHoursComponent {
  @Input() entityId: number = 0;
  @Input() entityType: string = '';
  @Input() editing: boolean = false;
  @Input() deletingBuilding: boolean = false;

  public officeHours: IOfficeHours = {
    id: 0,
    licenseId: '',
    sunday: '',
    monday: '',
    tuesday: '',
    wednesday: '',
    thursday: '',
    friday: '',
    saturday: ''
  }

  public officeHoursForm = new FormGroup({
    sunday: new FormControl('', Validators.required),
    monday: new FormControl('', Validators.required),
    tuesday: new FormControl('', Validators.required),
    wednesday: new FormControl('', Validators.required),
    thursday: new FormControl('', Validators.required),
    friday: new FormControl('', Validators.required),
    saturday: new FormControl('', Validators.required)
  });

  public service: OfficeHoursService = inject(OfficeHoursService);
  public sharedService: SharedService = inject(SharedService);

  ngOnInit(): void {
    this.getOfficeHours();
  }

  ngOnDestroy(): void {
    if(!this.deletingBuilding)
      this.updateHours();
  }

  public getOfficeHours() {
    this.service.getOfficeHours(this.entityId, this.entityType).subscribe ({
      next: response => this.officeHours = response,
      error: e => console.log('error getting office hours', e),
      complete: () => {
        this.updateOfficeHoursForm();
      }
    });
  }

  updateHours(): void {
    if(this.entityId === 0)
      return;
    if(this.officeHours.id === 0 && this.officeHoursForm.dirty) {
      this.createOfficeHours();
    } else {
      if(this.officeHoursForm.dirty){
        this.saveOfficeHours();
      }
    }
  }

  updateOfficeHoursForm(): void {
    this.officeHoursForm.reset({
      sunday: this.officeHours.sunday,
      monday: this.officeHours.monday,
      tuesday: this.officeHours.tuesday,
      wednesday: this.officeHours.wednesday,
      thursday: this.officeHours.thursday,
      friday: this.officeHours.friday,
      saturday: this.officeHours.saturday
    });
  }

  updateOfficeHours(): void {
    let form = this.officeHoursForm.getRawValue();
    this.officeHours.sunday = form.sunday ?? '';
    this.officeHours.monday = form.monday ?? '';
    this.officeHours.tuesday = form.tuesday ?? '';
    this.officeHours.wednesday = form.wednesday ?? '';
    this.officeHours.thursday = form.thursday ?? '';
    this.officeHours.friday = form.friday ?? '';
    this.officeHours.saturday = form.saturday ?? '';
  }

  saveOfficeHours(): void {
    this.updateOfficeHours();
    this.service.updateOfficeHours(this.officeHours).subscribe({
      complete: () => {},
      error: e => {
        console.log('Could not save office hours', e);
      }
    });
  }

  createOfficeHours(): void {
    this.updateOfficeHours();
    this.service.createOfficeHours(this.officeHours, this.entityId, this.entityType).subscribe({
      complete: () => {},
      error: e => {
        console.log('Could not create office hours', e);
      }
    });
  }
}
